import React, { useState, useEffect } from 'react';
import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom'; 
import { useAuth } from '../../context/AuthContext';
import { Menu, X, ChevronLeft, ChevronRight } from 'lucide-react'; 
import './AdminLayout.css'; // Asegúrate de que este archivo CSS exista

const AdminLayout = () => {
    const { logout, user } = useAuth(); 
    const navigate = useNavigate(); 
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 768) {
                setIsSidebarCollapsed(true); 
            } else {
                setIsSidebarCollapsed(false); 
                setIsMobileMenuOpen(false); 
            }
        };

        window.addEventListener('resize', handleResize);
        handleResize(); 

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleLogout = () => {
        logout(); 
        navigate('/login');
        setIsMobileMenuOpen(false); 
    };

    const toggleSidebar = () => {
        if (window.innerWidth <= 768) {
            setIsMobileMenuOpen(!isMobileMenuOpen);
        } else {
            setIsSidebarCollapsed(!isSidebarCollapsed);
        }
    };

    return (
        <div className={`admin-layout ${isSidebarCollapsed ? 'collapsed' : ''} ${isMobileMenuOpen ? 'mobile-menu-open' : ''}`}>
            <button onClick={toggleSidebar} className="sidebar-toggle-button mobile-only">
                <Menu size={24} />
            </button>
            {isMobileMenuOpen && <div className="mobile-sidebar-overlay" onClick={() => setIsMobileMenuOpen(false)}></div>}

            <aside className="sidebar">
                <div className="sidebar-header">
                    <h2>EduCertify</h2>
                    {window.innerWidth <= 768 && isMobileMenuOpen && (
                        <button onClick={toggleSidebar} className="sidebar-toggle-button close-mobile-menu">
                            <X size={24} />
                        </button>
                    )}
                    {window.innerWidth > 768 && (
                        <button onClick={toggleSidebar} className="sidebar-toggle-button desktop-only">
                            {isSidebarCollapsed ? <ChevronRight size={24} /> : <ChevronLeft size={24} />}
                        </button>
                    )}
                </div>
                
                {user && (
                    <div className="user-info">
                        <span className="material-icons user-icon">account_circle</span>
                        {!isSidebarCollapsed && <span className="username">{user.username}</span>}
                    </div>
                )}
                <nav className="sidebar-nav">
                    <ul>
                        <li>
                            <NavLink 
                                to="/admin" 
                                end 
                                className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
                                onClick={() => window.innerWidth <= 768 && setIsMobileMenuOpen(false)}
                            >
                                <span className="material-icons">dashboard</span>
                                {!isSidebarCollapsed && 'Dashboard'}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink 
                                to="/admin/upload" 
                                className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
                                onClick={() => window.innerWidth <= 768 && setIsMobileMenuOpen(false)}
                            >
                                <span className="material-icons">upload_file</span>
                                {!isSidebarCollapsed && 'Cargar Certificados'}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink 
                                to="/admin/certificates" 
                                className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
                                onClick={() => window.innerWidth <= 768 && setIsMobileMenuOpen(false)}
                            >
                                <span className="material-icons">list_alt</span>
                                {!isSidebarCollapsed && 'Lista de Certificados'}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink 
                                to="/admin/templates" 
                                className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
                                onClick={() => window.innerWidth <= 768 && setIsMobileMenuOpen(false)}
                            >
                                <span className="material-icons">design_services</span>
                                {!isSidebarCollapsed && 'Plantillas'}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink 
                                to="/admin/events" 
                                className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
                                onClick={() => window.innerWidth <= 768 && setIsMobileMenuOpen(false)}
                            >
                                <span className="material-icons">event</span>
                                {!isSidebarCollapsed && 'Gestión de Eventos'}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink 
                                to="/admin/organizers" 
                                className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
                                onClick={() => window.innerWidth <= 768 && setIsMobileMenuOpen(false)}
                            >
                                <span className="material-icons">business</span>
                                {!isSidebarCollapsed && 'Gestión de Organizadores'}
                            </NavLink>
                        </li>
                        <li>
                            <NavLink 
                                to="/admin/signatures" 
                                className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
                                onClick={() => window.innerWidth <= 768 && setIsMobileMenuOpen(false)}
                            >
                                <span className="material-icons">draw</span>
                                {!isSidebarCollapsed && 'Gestión de Firmas'}
                            </NavLink>
                        </li>
                        {/* NUEVO: Enlace para Gestión de Participantes */}
                        <li>
                            <NavLink 
                                to="/admin/participants" 
                                className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
                                onClick={() => window.innerWidth <= 768 && setIsMobileMenuOpen(false)}
                            >
                                <span className="material-icons">group</span> {/* Icono para participantes */}
                                {!isSidebarCollapsed && 'Gestión de Participantes'}
                            </NavLink>
                        </li>
                    </ul>
                </nav>
                <div className="sidebar-footer">
                    {!isSidebarCollapsed && <p>&copy; 2025 EduCertify</p>}
                    <button onClick={handleLogout} className="logout-button">
                        <span className="material-icons">logout</span>
                        {!isSidebarCollapsed && 'Cerrar Sesión'}
                    </button>
                </div>
            </aside>
            <main className="main-content">
                <Outlet /> 
            </main>
        </div>
    );
};

export default AdminLayout;
